import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GamesTableComponent } from '../games-table/games-table.component';
import { ClashDefinitionComponent } from './clash-definition/clash-definition.component';
import { GroupKeyComponent } from './group-key/group-key.component';
import { ModalArenaComponent } from './modal-arena/modal-arena.component';
import { StepParameterizationComponentForm } from './step-parameterization-form/step-parameterization-form.component';
import { StepParameterizationComponentList } from './step-parameterization-list/step-parameterization-list.component';
import { KeyManagementComponent } from './key-management/key-management.component';
import { RoundManagementComponent } from './round-management/round-management.component';
import { RoundManagementWithLocalComponent } from './round-management/round-management-with-local/round-management-with-local.component';

const routes: Routes = [
  {
    path: '',
    component: StepParameterizationComponentList,
    data: { mode: 'DEFAULT' }
  },
  {
    path: 'gerenciar-chaves',
    component: StepParameterizationComponentList,
    data: { mode: 'KEY_MANAGEMENT' }
  },
  {
    path: 'gerenciar-rodadas',
    component: StepParameterizationComponentList,
    data: { mode: 'ROUND_MANAGEMENT' }
  },
  {
    path: 'gerenciar-rodadas/:petNrId',
    component: RoundManagementComponent,
  },
  {
    path: 'gerenciar-rodadas-e-confrontos',
    component: RoundManagementWithLocalComponent,
    data: { mode: 'ROUND_MANAGEMENT_WITH_LOCAL' },
  },
  {
    path: 'criar',
    component: StepParameterizationComponentForm,
  },
  {
    path: 'editar/:petNrId',
    component: StepParameterizationComponentForm,
  },
  {
    path: 'gerenciar-chaves/:petNrId',
    component: KeyManagementComponent,
  },
  {
    path: 'editar/:petNrId/chave-grupo/:cheNrId/:petBlChaveBloqueada/:initialTab',
    component: GroupKeyComponent,
  },
  {
    path: 'definicao-embates',
    component: ClashDefinitionComponent,
  },
  {
    path: 'definicao-arena',
    component: ModalArenaComponent,
  },
  {
    path: 'tabela-jogos',
    component: GamesTableComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StepParameterizationRoutingModule {}
